/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Animal_CountryInputs */

const en_attribute_animal_country = /** @type {(inputs: Attribute_Animal_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animal country of origin`)
};

/**
* | output |
* | --- |
* | "Animal country of origin" |
*
* @param {Attribute_Animal_CountryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_animal_country = /** @type {((inputs?: Attribute_Animal_CountryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Animal_CountryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_animal_country(inputs)
});